import script from "./BaseFormWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFormWizard.vue?vue&type=script&setup=true&lang=js"

import "./BaseFormWizard.vue?vue&type=style&index=0&id=34f6a521&lang=css"

const __exports__ = script;

export default __exports__